export default __webpack_public_path__ + "static/media/id-verification.2c2bcd64.png";